import { createRestClient } from '@/contexts/QueryProvider'

export const useListImages = () => {
  // ✅ Create the rest client
  const restClient = createRestClient()

  // ✅ Destructure and use the predefined API query
  return restClient.getSupportApiListImages.useQuery()
}
